/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const axiosPayLoad = {
  rebateCodeSerchResult: [],
  selectedParentKey: null,
  loading: false,
  compareRebateCodeSearchResult: [],
  dataChangeTried: 0,
  errorMessage: '',
  successMessages: '',
  childCodeValueError: false,
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_CODETABLE_DATA:
      return { ...state, rebateCodeSerchResult: action.rebateCodeSerchResult };
    case actionTypes.COMPARE_CODETABLE_DATA:
      return { ...state, compareRebateCodeSearchResult: action.payload };
    case actionTypes.CODETABLE_DATA_LOADING:
      return { ...state, loading: action.payload };
    case actionTypes.SELECTED_PARENT_ROW:
      return { ...state, parentrow: action.payload };
    case actionTypes.CODETABLE_DATA_ROW_SELECTED:
      return { ...state, selectedParentKey: action.payload };
    case actionTypes.CODE_TABLE_ERROR_MESSAGE:
      return { ...state, errorMessage: action.payload };
    case actionTypes.CODE_TABLE_SUCCESS_MESSAGE:
      return { ...state, successMessages: action.payload };
    case actionTypes.CHILD_CODE_VALUE_ERROR:
      return { ...state, childCodeValueError: action.payload };
    case actionTypes.CODE_TABLE_DATA_CHANGE_TRIED:
      return { ...state, dataChangeTried: action.payload };
    case actionTypes.RESET_CODETABLE_STORE:
      return { ...axiosPayLoad };
    case actionTypes.SET_SELECTED_PARENT_PROTECTED_IND:
      return { ...state, selectedParentInd: action.selectedParentInd };
    case actionTypes.CODE_VALUE_DUPLICATE:
      return { ...state, isDuplicate: action.isDuplicate };
    default:
      return state;
  }
};

export default reducer;
